import styled from "styled-components";

export const PlayerName = styled.p`
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0.25rem;
  border: 0;
  text-shadow: 0 0 1rem #000a;
`;
